export var CurrentStep;
(function (CurrentStep) {
    CurrentStep[CurrentStep["Core"] = 1] = "Core";
    CurrentStep[CurrentStep["Event"] = 2] = "Event";
})(CurrentStep || (CurrentStep = {}));
export const orderValidForQuote = (quoteFields) => {
    return !!(quoteFields.activity_id &&
        quoteFields.state_id &&
        quoteFields.start_date &&
        quoteFields.end_date &&
        (quoteFields.daily_attendance || 0) > 0);
};
export const rateImpactingFields = (order) => {
    return {
        activity_id: order.activity_id,
        state_id: order.state_id,
        start_date: order.event_attributes?.start_date,
        end_date: order.event_attributes?.end_date,
        daily_attendance: order.event_attributes?.daily_attendance,
    };
};
